import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BracketItemService } from 'src/app/services/bracket-item.service';

@Component({
  selector: 'app-bracket-wrapper',
  templateUrl: './bracket-wrapper.component.html',
  styleUrls: ['./bracket-wrapper.component.scss']
})
export class BracketWrapperComponent implements OnInit {

  @ViewChild('wrapper') wrapper: ElementRef;

  private pos;
  private isMouseDown: boolean = false;

  public zoomLevel = 10;
  public zoomInDisabled: boolean = true;
  public zoomOutDisabled: boolean = false;
  public bracketElement;

  constructor(
    private bracketItemService: BracketItemService,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const target = document.querySelector(`#match-1`);
    target.scrollIntoView({
      block: 'center',
      inline: 'center',
    });

    this.bracketItemService.scrollEmitter.subscribe(event => {
      if (event.event == 'scrollTo') {
        const target = document.querySelector(`#match-${event.num}`);
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
        this.bracketItemService.highligh(event.num);
      }
    });
    this.bracketElement = document.querySelector(`#bracket-element`);
  }

  mouseDown($event) {
    this.wrapper.nativeElement.style.cursor = 'grabbing';
    this.wrapper.nativeElement.style.userSelect = 'none';

    this.pos = {
      left: this.wrapper.nativeElement.scrollLeft,
      top: this.wrapper.nativeElement.scrollTop,
      x: $event.clientX,
      y: $event.clientY,
    };

    this.isMouseDown = true;
  }

  mouseMove($event) {
    if (!this.isMouseDown) {
      return;
    }

    const dx = $event.clientX - this.pos.x;
    const dy = $event.clientY - this.pos.y;

    this.wrapper.nativeElement.scrollLeft = this.pos.left - dx;
    this.wrapper.nativeElement.scrollTop = this.pos.top - dy;
  }

  mouseUp($event) {
    this.isMouseDown = false;
    this.wrapper.nativeElement.style.cursor = 'grab';
    this.wrapper.nativeElement.style.removeProperty('user-select');
  }

  zoomIn() {
    this.bracketElement.classList.remove(`zoom-${this.zoomLevel}`);
    this.zoomLevel++;
    this.bracketElement.classList.add(`zoom-${this.zoomLevel}`);
    this.zoomInDisabled = this.zoomLevel == 10;
    this.zoomOutDisabled = this.zoomLevel == 1;
  }

  zoomOut() {
    this.bracketElement.classList.remove(`zoom-${this.zoomLevel}`);
    this.zoomLevel--;
    this.bracketElement.classList.add(`zoom-${this.zoomLevel}`);
    this.zoomInDisabled = this.zoomLevel == 10;
    this.zoomOutDisabled = this.zoomLevel == 1;
  }

}
